<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户ID">
                  <!-- <el-input  v-model="queryForm.userId"></el-input> -->
                  <GridSelectU title="选择用户" style="width: 200px;" labelName="userName" labelValue="id" :value="queryForm.userId" :limit='1'
                    size='small' placeholder='请选择用户' @getValue="getSeachValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="账号">
                  <el-input style="width: 200px;" v-model="queryForm.account"></el-input>
              </el-form-item>
              <el-form-item label="账号名称">
                  <el-input style="width: 200px;" v-model="queryForm.accountName"></el-input>
              </el-form-item>
              <el-form-item label="是否是默认">
                  <!-- <el-input style="width: 200px;" v-model="queryForm.isDefault"></el-input> -->
                  <el-select style="width: 200px;" v-model="queryForm.isDefault" placeholder="请选择">
                    <el-option
                      v-for="item in YesNoList"
                      :key="item.value"
                      :label="item.value"
                      :value="item.key"
                    ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMcnAccountAuthList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addMcnAccountAuth"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMcnAccountAuth(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMcnAccountAuth(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportMcnAccountAuthList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshMcnAccountAuthList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mcnAccountAuthList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户ID"
        width="180"
      >
        <template slot-scope='scope'>
            <div v-if="scope.row.user">
              <div style='text-align: left'>账号：{{ scope.row.user.userName }}</div>
              <div style='text-align: left'>手机：{{ scope.row.user.userMobile }}</div>
              <div style='text-align: left'>昵称：{{ scope.row.user.userNickname }}</div>
              <div style='text-align: left'>姓名：{{ scope.row.user.userRealname }}</div>
            </div>
            <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="account"
        label="账号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="accountName"
        label="账号名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="accountLogo"
        label="账号LOGO"
        width="180"
      >
        <template slot-scope="scope">
          <div v-if='scope.row.accountLogo'>
            <el-image @click='updateSrcList(scope.row.accountLogo)' style="width: 60px; height: 60px"
              :src="scope.row.accountLogo" :preview-src-list="srcList"> </el-image>
          </div>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="authExpireTime"
        label="授权到期时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isDefault"
        label="是否是默认"
        width="180"
      >
        <template slot-scope="scope">
          {{ YesNoItem(scope.row.isDefault) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMcnAccountAuth(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editMcnAccountAuth(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteMcnAccountAuth(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mcnAccountAuthStates[mcnAccountAuthState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mcnAccountAuth"
          ref="mcnAccountAuthForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户ID"
            prop="userId"
          >
            <!-- <el-input
              size="small"
              v-model="mcnAccountAuth.userId"
              :disabled="mcnAccountAuthState == 'check'"
            ></el-input> -->
            <GridSelectU style="width: 200px;" labelName="userName" :disabled="mcnAccountAuthState == 'check'"
              labelValue="id" title="选择用户" :value="mcnAccountAuth.userId" :limit='1' size='small' placeholder='请选择用户'
              @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
            </GridSelectU>
          </el-form-item>
          <el-form-item
            label="账号"
            prop="account"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="mcnAccountAuth.account"
              :disabled="mcnAccountAuthState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="账号名称"
            prop="accountName"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="mcnAccountAuth.accountName"
              :disabled="mcnAccountAuthState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="授权到期时间"
            prop="authExpireTime"
          >
            <!-- <el-input
              size="small"
              style="width: 200px;"
              v-model="mcnAccountAuth.authExpireTime"
              :disabled="mcnAccountAuthState == 'check'"
            ></el-input> -->
            <el-date-picker
                :disabled="mcnAccountAuthState == 'check'"
                v-model="mcnAccountAuth.authExpireTime"
                type="datetime"
                style="width: 200px;"
                placeholder="选择日期时间"
                size="small"
                format='yyyy-MM-dd HH:mm:ss'
                value-format='yyyy-MM-dd HH:mm:ss'>
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="是否是默认"
            prop="isDefault"
          >
            <!-- <el-input
              size="small"
              style="width: 200px;"
              v-model="mcnAccountAuth.isDefault"
              :disabled="mcnAccountAuthState == 'check'"
            ></el-input> -->
            <el-select
              :disabled="mcnAccountAuthState == 'check'"
              v-model="mcnAccountAuth.isDefault"
              placeholder="请选择"
              style="width: 200px;"
              size="small">
              <el-option
                v-for="item in YesNoList"
                :key="item.value"
                :label="item.value"
                :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="账号LOGO"
            prop="accountLogo"
          >
            <!-- <el-input
              size="small"
              style="width: 200px;"
              v-model="mcnAccountAuth.accountLogo"
              :disabled="mcnAccountAuthState == 'check'"
            ></el-input> -->
            <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
              :disabled="mcnAccountAuthState == 'check'" class="avatar-uploader" :show-file-list="false"
              :http-request="uploadImage">
              <img v-if="mcnAccountAuth.accountLogo" :src="mcnAccountAuth.accountLogo" class="avatar" size="small" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mcnAccountAuthState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import { UPLOAD_PATH, UPLOAD_API,USER,USER_SEARCH } from '@/utils/constant.js';
import GridSelectU from '@/components/gridselect';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectU
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMcnAccountAuthList();
                    this.getMcnAccountAuthList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMcnAccountAuthList();
                    this.getMcnAccountAuthList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     userId: '', //用户ID
                     account: '', //账号
                     accountName: '', //账号名称
                     accountLogo: '', //账号LOGO
                     authExpireTime: '', //授权到期时间
                     isDefault: '', //是否是默认
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                header: {
                  token: localStorage.getItem('token')
                },
                action: UPLOAD_API + UPLOAD_PATH,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                srcList: [''],
                mcnAccountAuthState: 'add',
                mcnAccountAuthStates: {
                    add: '新建授权账号',
                    check: '查看授权账号',
                    edit: '修改授权账号'
                },

                multipleSelection: [],
                mcnAccountAuthList: [],
                mcnAccountAuth: {
                    id: '', //ID
                    userId: '', //用户ID
                    account: '', //账号
                    accountName: '', //账号名称
                    accountLogo: '', //账号LOGO
                    authExpireTime: '', //授权到期时间
                    isDefault: '', //是否是默认
                },
                btnLoading: false,
                YesNoList: [],
                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }],
                    account: [{ required: true, message: '账号不能为空', trigger: 'blur' }],
                    accountName: [{ required: true, message: '账号名称不能为空', trigger: 'blur' }],
                    accountLogo: [{ required: true, message: '账号LOGO不能为空', trigger: 'blur' }],
                    authExpireTime: [{ required: true, message: '授权到期时间不能为空', trigger: 'blur' }],
                    isDefault: [{ required: true, message: '是否是默认不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getMcnAccountAuthList();
            this.getYesNoList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            updateSrcList(src){
                this.srcList[0] = src;
            },
            resetMcnAccountAuthList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mcnAccountAuthList = [];
            },
            // 搜索用户
            getSeachValueUser(value){
              this.queryForm.userId = value
            },
            getValueUser(value) {
              this.mcnAccountAuth.userId = value
            },
            beforeImageUpload(file) {
              const isLt2M = file.size / 1024 / 1024 < 50;
              if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 50MB!');
              }
              return isLt2M;
            },
            //上传缩略图
            uploadImage(params) {
              console.log(params);
              const file = params.file;
              let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
              if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
              }
              const formData = new FormData();
              formData.append('file', file);
              upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                  this.mcnAccountAuth.accountLogo = res.url;
                }
              });
            },
            getYesNoList(){
              get('/mpp/utils/getEnum', { enumType: 'yes_no' }).then((res) => {
                this.YesNoList = res.enumList;
              });
            },
            YesNoItem(keys){
              for (const key in this.YesNoList) {
                if(this.YesNoList[key].key == keys){
                  return this.YesNoList[key].value
                }
              }
            },
            resetDialog() {
                this.mcnAccountAuthState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户ID
                      account: '', //账号
                      accountName: '', //账号名称
                      accountLogo: '', //账号LOGO
                      authExpireTime: '', //授权到期时间
                      isDefault: '', //是否是默认
                };
                this.getMcnAccountAuthList();
            },
            closeDialog() {
                this.showDialog = false
                this.mcnAccountAuth = {
                      id: '', //ID
                      userId: '', //用户ID
                      account: '', //账号
                      accountName: '', //账号名称
                      accountLogo: '', //账号LOGO
                      authExpireTime: '', //授权到期时间
                      isDefault: '', //是否是默认
                };
            },
            submitForm() {
                if (this.mcnAccountAuthState == 'add') {
                    this.$refs.mcnAccountAuthForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mcn/accountauth/add`,{ ...this.mcnAccountAuth }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMcnAccountAuthList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.mcnAccountAuthState == 'edit') {
                    this.$refs.mcnAccountAuthForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.mcnAccountAuth.user
                            post(`/mcn/accountauth/edit`,{ ...this.mcnAccountAuth }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMcnAccountAuthList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addMcnAccountAuth() {
                this.showDialog = true;
                this.mcnAccountAuthState = 'add';
            },
            checkMcnAccountAuth(mcnAccountAuthId) {
                console.log(mcnAccountAuthId);
                this.currentMcnAccountAuthId = mcnAccountAuthId;

                this.getMcnAccountAuthById();
                this.showDialog = true;
                this.mcnAccountAuthState = 'check';
            },
            editMcnAccountAuth(mcnAccountAuthId) {
                console.log('mcnAccountAuth', mcnAccountAuthId);
                if (mcnAccountAuthId) {
                    this.currentMcnAccountAuthId = mcnAccountAuthId;
                    this.getMcnAccountAuthById();
                } else {
                    this.mcnAccountAuth = { ...this.mcnAccountAuth, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mcnAccountAuthState = 'edit';
            },
            deleteMcnAccountAuth(mcnAccountAuthId) {
                let ids = '';
                if (mcnAccountAuthId) {
                    ids = mcnAccountAuthId;
                } else {
                    ids = this.multipleSelection.map((mcnAccountAuth) => mcnAccountAuth.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mcn/accountauth/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMcnAccountAuthList();
                                this.getMcnAccountAuthList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMcnAccountAuthList() {
                this.resetMcnAccountAuthList();
                this.getMcnAccountAuthList();
            },
            getMcnAccountAuthList(query = {}) {
                this.loading = true;
                get(`/mcn/accountauth/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mcnAccountAuthList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getMcnAccountAuthById() {
                get(`/mcn/accountauth/get`,{ id: this.currentMcnAccountAuthId }).then((res) =>{
                    if(res.success){
                      this.mcnAccountAuth = { ...this.mcnAccountAuth, ...res.mcnAccountAuth };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMcnAccountAuthList() {
                //this.btnLoading = true;
                exprotExcel(`/mcn/accountauth/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mcn/accountauth/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mcn/accountauth/importData`,formData);
              this.refreshMcnAccountAuthList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMcnAccountAuthList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMcnAccountAuthList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.avatar {
  width: 200px;
  height: 200px;
  display: block;
}

::v-deep .el-upload--text {
  width: 200px;
  height: 200px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 200px;
  line-height: 200px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>